import React, { useEffect } from 'react';

interface SetupStep {
  title: string;
  videoUrl: string;
}

interface Props {
  setIsStepValid: (isValid: boolean) => void;
}

const setupSteps: SetupStep[] = [
  {
    title: 'Setup business account',
    videoUrl: 'https://www.youtube.com/embed/VIDEO_ID_1', // Replace VIDEO_ID_1 with the actual YouTube video ID
  },
  {
    title: 'Setup Facebook page',
    videoUrl: 'https://www.youtube.com/embed/VIDEO_ID_2', // Replace VIDEO_ID_2 with the actual YouTube video ID
  },
  {
    title: 'Setup Ad Account',
    videoUrl: 'https://www.youtube.com/embed/VIDEO_ID_3', // Replace VIDEO_ID_3 with the actual YouTube video ID
  },
  {
    title: 'Setup dataset',
    videoUrl: 'https://www.youtube.com/embed/VIDEO_ID_4', // Replace VIDEO_ID_4 with the actual YouTube video ID
  },
];

const AccountSetupIntro: React.FC<Props> = ({ setIsStepValid }) => {
  useEffect(() => {
    setIsStepValid(true);
  }, []);

  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl">
      <h2 className="text-[28px] text-center font-semibold font-inter text-black mb-10">
        Account Setup
      </h2>
      <div className="space-y-6">
        {setupSteps.map((step, index) => (
          <div key={index} className="p-4 border border-gray-200 rounded-lg shadow-sm">
            <h3 className="text-lg font-semibold text-black mb-4">{step.title}</h3>
            <div className="relative">
              {/* Use an iframe to embed YouTube videos */}
              <iframe
                src={step.videoUrl}
                title={step.title}
                className="w-full h-60 rounded-lg"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountSetupIntro;